import { createStandardAction } from 'typesafe-actions';
import { CalendarHolidays } from 'CalendarHoliday-Types';

export const setCalendarHolidays = createStandardAction('SET_CALENDAR_HOLIDAYS')<
  CalendarHolidays
>();
